import React from 'react';

import getPropsForComponent from '@adsk/bim360-matrix-react-helpers/es/getPropsForComponent';
import Field from './Field';

export default (InnerComponent, valueGetter) => {
  /**
   * HOC to wrap other inputs with label
   */
  class FieldHOCComponent extends React.Component {
    /**
     *
     * @param props
     */
    constructor(props) {
      super(props);
    }

    /**
     * Here in case the InnerComponent is wrapped with a onClickOutside HOC
     */
    handleClickOutside() {
      if (this.inner && this.inner.handleClickOutside) {
        this.inner.handleClickOutside();
      }
    }

    /**
     *
     * @returns {XML}
     */
    render() {
      return (
        <Field {...getPropsForComponent(this.props, Field)} valueGetter={this.props.valueGetter}>
          <InnerComponent
            ref={inner => {
              this.inner = inner;
            }}
            {...getPropsForComponent(this.props, InnerComponent)}
          />
        </Field>
      );
    }
  }

  FieldHOCComponent.defaultProps = {
    valueGetter
  };

  FieldHOCComponent.propTypes = {
    ...InnerComponent.propTypes,
    ...Field.propTypes
  };

  return FieldHOCComponent;
};
